import { useEffect, useState } from 'react'
import {
  faNode,
  faCss3,
  faGitAlt,
  faJsSquare,
  faReact,
  faSymfony,
} from '@fortawesome/free-brands-svg-icons'
import Loader from 'react-loaders'
import AnimatedLetters from '../AnimatedLetters'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './index.scss'

const About = () => {
  const [letterClass, setLetterClass] = useState('text-animate')

  useEffect(() => {
    const timer = setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)

    return () => clearTimeout(timer)
  }, [])

  return (
    <>
      <div className="container about-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={['A', 'b', 'o', 'u', 't', ' ', 'm', 'e']}
              idx={15}
            />
          </h1>
          <p>
            I'm a very ambitious front-end developer seeking a role in a
            well-established IT company with the opportunity to work with the
            latest technologies on challenging and diverse projects.
          </p>
          <p>
            I'm a team player and always eager to learn, constantly striving to
            improve my skills by solving design problems one step at a time.
          </p>
          <p>
            To sum it up in one sentence, I'm a family-oriented person, the
            proud father of a beautiful daughter, a sports fanatic, photography
            enthusiast, and tech-obsessed! Outside of work, I'm an avid runner
            and passionate about astrophysics and quantum physics, as well as
            interested in home automation and astronomy.
          </p>
        </div>

        <div className="stage-cube-cont">
          <div className="cubespinner">
            <div className="face1">
              <FontAwesomeIcon icon={faSymfony} color="#DD0031" />
            </div>
            {/* <div className="face2">
              <FontAwesomeIcon icon={faHtml5} color="#F06529" />
            </div> */}
            <div className="face3">
              <FontAwesomeIcon icon={faCss3} color="#28A4D9" />
            </div>
            <div className="face4">
              <FontAwesomeIcon icon={faReact} color="#5ED4F4" />
            </div>
            <div className="face5">
              <FontAwesomeIcon icon={faJsSquare} color="#EFD81D" />
            </div>
            <div className="face6">
              <FontAwesomeIcon icon={faGitAlt} color="#EC4D28" />
            </div>
            <div className="face8">
              <FontAwesomeIcon icon={faNode} color="#EC4D28" />
            </div>
          </div>
        </div>
      </div>
      <Loader type="pacman" />
    </>
  )
}

export default About
